<div class="container">
  <div class="row justify-content-center">
    <section class="col-12 col-xl-11">
      <h3>{{'FAQ - Most frequently asked questions' | translate}}</h3>
    </section>
  </div>
  <div class="row justify-content-center">
    <section class="col-12 col-xl-11">
      <ul>
        <li>
          <h4></h4>
          <p class="pb-3"></p>
        </li>
      </ul>
    </section>
  </div>
</div>
